import { Component } from '@angular/core';

@Component({
  selector: 'app-typebedroom-form',
  templateUrl: './typebedroom-form.component.html',
  styleUrls: ['./typebedroom-form.component.css']
})
export class TypebedroomFormComponent {

}
